<script setup lang="ts">
import { computed } from 'vue';

import VisionAIDashboardReportContent from '@/components/VisionAi/SummaryMediaWidget/VisionAIDashboardReportContent.vue';
import type { LegacyDashboardReportData } from '@/components/VisionAi/widgets/visionWidget.types.ts';

const props = defineProps<{
  widgetData: LegacyDashboardReportData;
}>();

const reports = computed(() => {
  const reportData = props.widgetData;
  return [
    {
      reportOverride: {
        ...reportData,
        visionAiReport: true,
      },
      type: reportData.type,
      shouldHideConversation: true,
    },
  ];
});
</script>

<template>
  <VisionAIDashboardReportContent :reports="reports" />
</template>
